import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';

const steps = [
  {
    label: 'After registering, shop from any brand on the app',
    description: `For each ad campaign that you create, you can control how much
          you're willing to spend on clicks and conversions, which networks
          and geographical locations you want your ads to show on, and more.`,
  },
  {
    label: 'Return to this page after shopping',
    description:
      'An ad group contains one or more ads which target a shared set of keywords.',
  },
  {
    label: 'Unlock your Mystery Gift Box & claim your Bonus Cashback',
    description: `Try out different ad text to see what brings in the most customers,
          and learn how to enhance your ads using features like ad extensions.
          If you run into any problems with your ads, find out how to tell if
          they're running and how to resolve approval issues.`,
  },
];

// Custom StepConnector with dashed line
const DashedConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.vertical}`]: {
    // marginLeft: 18,
    padding: 0,
    // Use dashed border for vertical line
    '& .MuiStepConnector-line': {
      borderLeftStyle: 'dashed',
      borderLeftWidth: 1.5,
      borderLeftColor: '#BFCFFF',
      minHeight: 24,
    },
  },
}));

function TestIcon(i) {
  return (
    <Typography
      sx={{
        height: '28px',
        width: '28px',
        borderRadius: '50%',
        backgroundColor: '#BFCFFF',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 600,
      }}
    >
      {i}
    </Typography>
  );
}

export default function VStepper() {
  const [activeStep, setActiveStep] = React.useState(2);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        connector={<DashedConnector />}
      >
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel StepIconComponent={() => TestIcon(index + 1)}>
              <Typography
                sx={{
                  fontFamily: 'DM Sans',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '130%',
                  letterSpacing: '0%',
                  verticalAlign: 'middle',
                  color: '#fff',
                }}
              >
                {step.label}
              </Typography>
            </StepLabel>
            <StepContent>{/* Step content here if needed */}</StepContent>
          </Step>
        ))}
      </Stepper>
     
    </Box>
  );
}
